import { AppConfig } from './types';

/**
 * Development environment configuration
 * Only specify values that differ from the default configuration
 */
export const developmentConfig: Partial<AppConfig> = {
  proctoring: {
    api: {
      baseUrl: 'https://api.dev.smarterproctoring.com',
      timeout: 30000,
      retryAttempts: 3
    }
  },
  assessment: {
    api: {
      baseUrl: '',
      timeout: 30000,
      retryAttempts: 3
    }
  },
  core : {
    api: {
      baseUrl: 'https://signon.dev.smarterproctoring.com',
      timeout: 30000,
      retryAttempts: 3
    }
  },
  media : {
    api: {
      baseUrl: 'https://api.dev.proctoring.media',
      timeout: 30000,
      retryAttempts: 3
    },
    playback: {
      baseUrl: 'https://playback.dev.proctoring.media',
    },    
    livekit: {
      websocketUrl: 'wss://media-dev-sfo2.proctoring.media',
    }
  },
  elements: {
    ui : {
      baseUrl: 'https://app.dev.smarterservices.com',
    }
  }
};
